import React, { useState, useContext } from "react";
import StatusBadge from "Components/statusBadge/StatusBadge";
import { lowerAndCapitalize } from "Utils/strings";
import { DropdownMenu } from "react-dd-menu";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import Tooltip from "Components/tooltip/Tooltip";
import { Icon, more, disable, manager, trash, enable, warningFill } from "Icons/index";
import { AuthContext, MediaQueriesContext } from "@/App";
import { Link } from "react-router-dom";
import t, { getAccountTypeTranslation } from "Utils/translation";
import { domainsPerDeliveryAccountsLimits } from "@/config";
import cx from "classnames";

const formatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, {
  maximumFractionDigits: 0,
});

const DeliveryAccountRow = ({
  accountData,
  onClick,
  isStatusUpdating = false,
  onStatusChangeButtonClick,
  statusChangeButtonLabel,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isMediaMobile } = useContext(MediaQueriesContext);
  const { isLoggedUserAdmin, getLoggedUser } = useContext(AuthContext);

  const loggedUser = getLoggedUser();
  const isManager = loggedUser.type === "Manager";

  const isFreeWithPendingOrder = accountData.plan === "free" && accountData.has_pending_order;

  return (
    <tr>
      <td className="flex items-center justify-center">
        <StatusBadge isUpdating={isStatusUpdating} isManager={isManager} data={accountData} type="delivery-account" />
      </td>
      <td>
        <div className="">
          {accountData.status_detail === "wait_pay" || isFreeWithPendingOrder ? (
            <div className="text-[10px] px-1 rounded bg-[rgba(250,187,5,0.30)] max-w-max">
              {isManager ? t("delivery.account.status.waitingCustomerApproval") : t("status.waitingPayment")}
            </div>
          ) : (
            ""
          )}
          <a onClick={onClick}>{accountData.description}</a>
        </div>
      </td>

      {isLoggedUserAdmin() ? (
        <td>{accountData.customer_fullname}</td>
      ) : (
        <td className="hidden sm:table-cell">{accountData.username}</td>
      )}

      <td className="hidden sm:table-cell">{getAccountTypeTranslation(accountData.type)}</td>

      <td className="hidden sm:table-cell">{t(`delivery.plan.${accountData.plan}`)}</td>

      <td className={isLoggedUserAdmin() ? "hidden sm:table-cell" : ""}>
        {formatter.format(accountData.remaining_messages)}
      </td>

      <td className={cx("hidden sm:table-cell")}>
        <div className="flex items-center gap-1">
          <div
            className={cx({
              "bg-[rgba(250,187,5,0.30)] px-1 py-1 rounded": accountData.domains_count === 0,
            })}
          >
            {accountData.domains_count}/
            {domainsPerDeliveryAccountsLimits[accountData.plan === "free" ? "free" : "paid"]}
          </div>
        </div>
      </td>

      <td className={cx("hidden sm:table-cell")}>
        <div className="flex items-center gap-1">
          <div
            className={cx({
              "bg-[rgba(250,187,5,0.30)] px-1 py-1 rounded": accountData.delete_on,
            })}
          >
            {accountData.delete_on
              ? t("delivery.accounts.label.deletingOn")
              : accountData.next_renewal_date
              ? accountData.next_renewal_date
              : "-"}
          </div>
        </div>
      </td>

      <td data-label={t("table.header.managers")} className={cx("justify-center", "hideOnMobile")}>
        {accountData.manager_fullname && !isManager && (
          <Tooltip title="manager" text={accountData.manager_fullname}>
            <Icon svg={manager} />
          </Tooltip>
        )}
      </td>

      <td>
        {accountData.status_detail !== "wait_pay" && (
          <DropdownMenu
            close={() => setIsMenuOpen(false)}
            animate={false}
            isOpen={isMenuOpen}
            toggle={
              <div style={isStatusUpdating ? { visibility: "hidden" } : {}}>
                <ButtonIcon
                  icon={more}
                  //eslint-disable-next-line
                  onClick={(e) => {
                    setIsMenuOpen((prev) => !prev);
                  }}
                />
              </div>
            }
            align="right"
          >
            <li>
              <a
                onClick={(e) => {
                  e.stopPropagation();
                  onStatusChangeButtonClick(accountData);
                  setIsMenuOpen(false);
                }}
              >
                <Icon svg={accountData.status ? disable : enable} />
                <div>{statusChangeButtonLabel}</div>
              </a>
            </li>

            <li>
              <Link
                to={
                  isLoggedUserAdmin()
                    ? `/customers/${accountData.customer_code}/delivery/accounts/${accountData.id}/service-management`
                    : `/delivery/accounts/${accountData.id}/service-management`
                }
              >
                <Icon svg={trash} />
                <div>{t("button.delete")}</div>
              </Link>
            </li>

            {isMediaMobile && (
              <li className="cancelBtn">
                <a>
                  <div>{t("ddMenu.cancel")}</div>
                </a>
              </li>
            )}
          </DropdownMenu>
        )}
      </td>
    </tr>
  );
};

export default DeliveryAccountRow;
